import { render, staticRenderFns } from "./BaseRegistrationForBusinessUserStepThree.vue?vue&type=template&id=54223198&"
import script from "./BaseRegistrationForBusinessUserStepThree.vue?vue&type=script&lang=js&"
export * from "./BaseRegistrationForBusinessUserStepThree.vue?vue&type=script&lang=js&"
import style0 from "./BaseRegistrationForBusinessUserStepThree.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports